import styles from "./PilotAirdrop.module.css";
import pilotABI from "../../config/pilotABI";
import {PilotChainId, PilotContractAddress, PilotNetwork} from "../../config/config";

import Web3 from "web3";
import {useWeb3React} from "@web3-react/core";
import { InjectedConnector } from '@web3-react/injected-connector';

import {useEffect, useState} from "react";
import pilotAirdropTitleImg from "asset/image/pilot/pilot-airdrop-title.png";
import {useTranslation} from "react-i18next";
import refreshIcon from "../../asset/icon/ic_refresh.svg";
import {Modal} from "@mui/material";
import {isMetaMask} from "../../utils/check-browser";
import {isAndroid, isMobile} from "react-device-detect";
import {PilotDeepLink} from "../../config/config";
import iconDone from "../../asset/image/pilot/icon-check-circle.png";
import iconError from "../../asset/image/pilot/icon-error-circle.png";
import iconClose from "asset/icon/ic_close_white_24dp.svg"


const PilotAirdropMobile = (props) => {

    const { t, i18n } = useTranslation();

    const { language } = props;

    const { active, account, activate, deactivate, chainId } = useWeb3React();
    const injectedConnector = new InjectedConnector();

    const [walletAddress, setWalletAddress] = useState("");
    const MINT_LIMIT = 100;
    const [mintableAmount, setMintableAmount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isMinting, setIsMinting] = useState(false);
    const [isMintingModalOpen, setIsMintingModalOpen] = useState(false);
    const [mintingModalIcon, setMintingModalIcon] = useState(
        <div className={styles["spinner"]}/>
    );
    const [mintingModalMessage, setMintingModalMessage] = useState(t("PILOT_NOTICE_MINTING"))
    const [isError, setIsError] = useState(false);
    const [buttonFunc, setButtonFunc] = useState(() => () => connectWallet());

    const injected = new InjectedConnector();

    const [isInit, setIsInit] = useState(true);

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);

    const connectWallet = async () => {
        if (active) {
            deactivate();
        }

        if (!isMetaMask()) {
            alert(t('META_MASK_BROWSER_GUIDE'));
            window.location.href = PilotDeepLink;
            return;
        }

        try {
            // 지갑 연결 시도
            const provider = await injected.getProvider();

            const currentChainId = await provider.request({ method: 'eth_chainId' });
            provider.on('chainChanged', handleChainChanged);


            if( currentChainId !== PilotChainId){
                alert(t("PILOT_NOTICE_PLZ_CHANGE_NETWORK"));
                try {
                    // 네트워크 변경 시도

                    await provider.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: PilotChainId }],
                    });

                    alert(t("PILOT_NOTICE_CHANGE_NETWORK"))

                } catch (switchError) {
                    // 에러코드 4902는 체인이 추가되지 않았을 때 발생
                    if (switchError.code === 4902) {
                        try {
                            // alert("네트워크 추가 시도");
                            await provider.request( {
                                method: 'wallet_addEthereumChain',
                                params: [PilotNetwork]
                            });

                        } catch (addError) {
                            // alert("네트워크 추가 실패");
                            alert(t("PILOT_NOTICE_CHANGE_NETWORK_ERROR"))

                            console.error('네트워크 추가 실패:', addError);
                            return;
                        }
                    } else {
                        console.error('네트워크 전환 실패:', switchError);
                    }
                }
            }

            await activate(injected, undefined, true);
            await callMintable();

        } catch (err) {
            const isMatch = err.message.match(
                'No Ethereum provider was found on window.ethereum',
            );
            if (isMatch) {
                window.open('https://metamask.io/download.html');
                return;
            }

            console.error(err);
        }

    };


    const handleChainChanged = async (chainId) => {
        // console.log('체인 변경됨:', chainId, parseInt(chainId, 16));
        // 필요한 경우 체인 ID 관련 로직 추가
        if(chainId !== PilotChainId) {
            await alert(t("PILOT_NOTICE_CHAIN_CHANGE_DETECTED"));
            window.location.reload(); // 또는 상태 업데이트로 처리
        }
    };

    const handleClickMintingModalCloseBtn = () => {
        if(isMinting){
            return;
        }

        setIsMintingModalOpen(false);
    }


    useEffect(() => {
        if(isInit){
            setIsInit(false);
            return;
        }

        setWalletAddress(account);

    }, [account])

    /**
     * 민팅 가능한 개수를 불러오는 함수
     * @returns {Promise<void>}
     */
    const callMintable = async () => {
        setIsLoading(true);

        if(!walletAddress){
            return;
        }

        try {
            const provider = new Web3(window.ethereum);
            const contract = new provider.eth.Contract(pilotABI, PilotContractAddress);

            const amount = await contract.methods.remainingAllocation(walletAddress).call();
            // console.log("remainingAllocation에서 가져온 amount: ", amount);
            setMintableAmount(Number(amount));
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    /**
     * 구매 가능한 nft를 모두 민팅하는 함수
     * @returns {Promise<void>}
     */
    const callMintAll = async () => {
        if (!window.ethereum) {
            // alert("지갑이 연결되지 않았습니다.");
            return;
        }

        // console.log("민팅 함수 호출");
        setIsMinting(true);
        setIsMintingModalOpen(true);
        setMintingModalMessage(t("PILOT_NOTICE_MINTING"));
        setMintingModalIcon(<div className={styles["spinner"]}/>);

        if (mintableAmount <= 0) {
            // console.log("거래 가능한 수량이 없습니다.");
            setIsMinting(false);
            setIsMintingModalOpen(false);
            return;
        }

        try {
            const provider = new Web3(window.ethereum);
            const contract = new provider.eth.Contract(pilotABI, PilotContractAddress);

            // console.log("민팅");
            const amount = Number(mintableAmount) <= Number(MINT_LIMIT) ? Number(mintableAmount) : Number(MINT_LIMIT);

            // console.log("MINT_LIMIT", MINT_LIMIT);
            // console.log("amount: ", amount);

            if (amount <= 0) {
                // console.log("amount <= 0");
                return;
            }

            // 현재 네트워크의 평균 가스 가격(wei 단위)
            const currentGasPrice = await provider.eth.getGasPrice();
            // console.log(`현재 가스 가격: ${provider.utils.fromWei(gasPrice, 'gwei')} gwei`);
            const gasPrice = Math.floor(currentGasPrice * 1.2);

            // 가스 사용량 추정
            const gasEstimate = await contract.methods.mintPartial(Number(amount)).estimateGas({
                from: walletAddress
            });

            // 사용 가스 한도를 1.2배로 여유분 설정 -> 실패 X, 사용되지 않은 가스는 환불됨
            const gasLimit = Math.floor(gasEstimate * 1.2);

            // 0.01gwei로 고정된 가스비 -> 너무 낮아서 동작하지 않음
            // const data = await contract.methods.mintPartial(Number(amount)).send({
            //     from: walletAddress,
            //     gasPrice: provider.utils.toWei('0.01', 'gwei')
            // });

            const data = await contract.methods.mintPartial(Number(amount)).send({
                from: walletAddress,
                gasPrice: gasPrice,
                gas: gasLimit
            });


            // console.log("민팅 성공");
            // console.log(data);
            // console.log("트랜잭션 해시: ", data.transactionHash);

            setMintingModalIcon(<img width={20} src={iconDone}></img>);
            setMintingModalMessage(t("PILOT_NOTICE_MINTING_SUCCESS", {amount : amount}));


            await callMintable();
        } catch (error) {
            // alert("오류가 발생했습니다.")

            setMintingModalIcon(<img width={20} src={iconError}></img>);
            setMintingModalMessage(t("PILOT_NOTICE_MINTING_CANCELED"));

            // console.log("민팅 실패");
            console.error(error);
        } finally {
            setIsMinting(false);
        }
    };

    useEffect(() => {
        if (!walletAddress) {
            return;
        }

        callMintable()
            .then(() => {
                setButtonFunc(() => () => callMintAll());
            })
            .catch((error) => {
                console.error(error);
            });

    }, [walletAddress, mintableAmount]);

    // 상단 안내 메시지
    const InfoMessage = () => {
        if (isLoading) {
            return t("PILOT_NOTICE_CONNECTING_WALLET");
        }

        if (isError) {
            return t("PILOT_NOTICE_WALLET_CONNECT_ERROR");
        }

        if (!walletAddress) {
            return t("PILOT_NOTICE_PLZ_CONNECT_WALLET_FIRST");
        }

        return t("PILOT_NOTICE_WALLET_CONNECTED")
    };


    // 버튼 메시지
    const BtnMessage = () => {
        if (isLoading) {
            return t("PILOT_NOTICE_WALLET_CONNECTED");
        }

        if (isError) {
            return "파일럿을 받을 수 없습니다.";
        }

        if (!walletAddress) {
            return t("PILOT_BTN_CONNECT_WALLET");
        }

        if (mintableAmount <= 0) {
            return t("PILOT_BTN_NO_AIRDROP");
        }

        return t("PILOT_BTN_CLAIM_AIRDROP");
    };

    return (
        <div className={styles["pilot-airdrop"]}>
            <section className={styles["title-container"]}>
                <div className={styles["badge"]}>
                    NOW
                </div>

                <div className={styles["pilot-airdrop-title"]}>
                    <img src={pilotAirdropTitleImg} alt=""/>
                    <div className={styles["glow"]}></div>
                </div>
            </section>

            <div className={styles["wrap"]}>
                <div className={styles["info-container"]}>
                    <div className={styles["desc"]}>
                        <InfoMessage/>
                    </div>

                    <div className={styles["wallet-container"]} style={{display: isLoading || isError || !walletAddress ? "none" : "flex"}} >
                        <div className={styles["desc"]}>
                            {
                                t("PILOT_NOTICE_CONNECTED_WALLET_ADDRESS")
                            }
                        </div>

                        <div className={styles["wallet-address"]}>
                            {walletAddress}
                        </div>

                        <div className={styles["ticket-amount"]}>
                            <div>
                                {t("AIRDROP_AMOUNT")}
                            </div>

                            <div className={styles["separator"]}/>

                            <div>
                                {mintableAmount}
                            </div>
                        </div>
                    </div>

                    <div className={styles["retry-btn"]}
                         onClick={connectWallet}
                         style={{display: isError && !isLoading ? "flex" : "none"}}
                    >
                        <img src={refreshIcon} alt="" style={{width: 20}}/>
                        {t("RETRY")}
                    </div>

                    <div className={styles["loading-container"]} style={{display: isLoading ? "flex" : "none"}} >
                        <div className={styles["spinner"]}/>
                    </div>
                </div>

                <button type={"button"} className={`
                    ${styles["pilot-airdrop-connect-btn"]} 
                    ${isLoading || isError || (walletAddress && mintableAmount <= 0) ? styles["loading"] : ""}
                `}
                        onClick={buttonFunc}
                        disabled={isMinting}
                >
                    <BtnMessage/>
                </button>
            </div>

            <section className={styles["bottom-glow-container"]}>
                <div className={styles["glow1"]}/>
                <div className={styles["glow2"]}/>
                <div className={styles["glow3"]}/>
            </section>

            {/* 민팅 로딩 모달 */}
            {isMintingModalOpen &&
                <Modal open={isMintingModalOpen}
                       onClose={() => {}}
                       className={styles["pilot-minting-modal"]}
                >
                    <div className={styles["pilot-minting-modal-content"]}>
                        <div
                            className={styles["pilot-minting-modal-content-header"]}
                            onClick={handleClickMintingModalCloseBtn}
                        >
                            <img src={iconClose} alt="" style={{visibility: isMinting ? "hidden" : "visible"}}/>
                        </div>

                        { mintingModalIcon }
                        { mintingModalMessage }
                    </div>
                </Modal>
            }

        </div>
    );
};

export default PilotAirdropMobile;